
import { useUI } from "providers/UIProvider"

import { Container } from "@chakra-ui/react"

import Modal from "components/UI/organisms/Modal"
import CancellationFeeTabs from "components/templates/SettingsTemplate/CancellationFeeTemplate/CancellationFeeTabs"
import CancellationFeeForm from "components/templates/SettingsTemplate/CancellationFeeTemplate/CancellationFeeForm"
import useCancellationFee from "hooks/useCancellationFee"
import { useSettings } from "providers/SettingsProvider/SettingsProvider"
import { BOOKING_FEE_TABS } from "types/shared"

const CancelReservationCommissionsModal = () => {
  const { modals, toggleModal, T } = useUI()
  const { cancelCommissions, handleChangeCancelCommissionsTab } = useSettings()
  const { form: { resetForm } } = useCancellationFee()

  const cancelCommissionsTabType = cancelCommissions[0]?.commissionType === 2 ? BOOKING_FEE_TABS.FIXED : BOOKING_FEE_TABS.PERCENT

  return (
    <Modal
      isOpen={modals.cancelReservationCommissionModal.isOpened}
      title={T("laundry.commission.booking_settings")}
      onClose={()=>{
        resetForm()
        handleChangeCancelCommissionsTab(cancelCommissionsTabType)
        toggleModal("cancelReservationCommissionModal", false)
      }}
      styles={{
        headerPadding: "20px 15px 20px 23px",
        width: "566px",
        bodyPadding: "0px 0px 0px 0px",
      }}
    >
      <Container padding="20px" display="flex" flexDirection="column" alignItems="center">
        <CancellationFeeTabs />
        <CancellationFeeForm />
      </Container>
    </Modal>
  )
}

export default CancelReservationCommissionsModal